// The Blue Byrd's HubSpot form, which replaced the site's own contact form.
// These identifiers are public: they ship in the client bundle and appear in
// the embed snippet HubSpot hands out, so they are deliberately not env vars.
export const HUBSPOT_FORM = {
  src: "https://js-na2.hsforms.net/forms/embed/247020105.js",
  region: "na2",
  portalId: "247020105",
  formId: "acabafa3-2615-46aa-81c6-1d3f943bf57a",
} as const;
